module.exports=function anonymous(obj,microTemplate
) {
var p=[],print=function(){p.push.apply(p,arguments);};with(obj){p.push('<div id="po-hours-importer" style="padding-top: 24px;"></div>');}return p.join('');
}